<div class="flex items-center justify-end gap-2 pt-2 @container">
  <span class="hidden text-sm text-text-common-contrast @lg:block">
    Items per page:
  </span>
  <div class="hidden @lg:block">
    <p-select
      [options]="pageSizeOptions"
      optionLabel="label"
      optionValue="value"
      size="small"
      appendTo="body"
      [ngModel]="rows()"
      (ngModelChange)="pageSizeChange.emit($event)"
    />
  </div>
  <p-paginator
    [first]="first()"
    [rows]="rows()"
    [totalRecords]="totalItems()"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="{first} - {last} of {totalRecords}"
    (onPageChange)="onPageChange($event)"
  />
</div>
